module.exports = __webpack_public_path__ + "img/brazil1.9a45b1cc.jpg";